
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/safer-dating",
      function () {
        return require("private-next-pages/[lang]/safer-dating/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/safer-dating"])
      });
    }
  